import Shuffle from 'shufflejs';
jQuery(window).on('load', function () {
  // var Shuffle = window.Shuffle;
  if (jQuery('.identity__filter-row').length) {
    var myShuffle = new Shuffle(document.querySelector('.identity__filter-row'), {
      itemSelector: '.imarc-col'
    });
    jQuery('.identity__filter-list a').each(function () {
      var link = jQuery(this);
      link.on('click', function (e) {
        e.preventDefault();
        jQuery('.identity__filter-list a').removeClass('active');
        jQuery(this).addClass('active');
        var keyword = link.attr('data-group');
        myShuffle.filter(keyword);
      });
    });
  }
});